const autoNgTemplateLoaderTemplate1 = require('./storidgeProfileSelector.html');

angular.module('shbdeployer.integrations.storidge').component('storidgeProfileSelector', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'StoridgeProfileSelectorController',
  bindings: {
    storidgeProfile: '=',
  },
});
